import { Flex, Typography } from '@duxton-web/ui';
import i18n from 'i18n-js';
import React from 'react';

import { UCD_ROUTES_LINK } from 'omega-rtc/constants/ucd';

type Props = {
  campaignIDs?: string[] | null;
  countryID?: string | number;
};

const label = (key: string) => i18n.t(`journey_campaign_trident_links.${key}`);

const JourneyTridentCampaignLinks = ({ campaignIDs, countryID }: Props) => {
  const ids = Array.from(new Set((Array.isArray(campaignIDs) ? campaignIDs : [])
    .filter((id) => typeof id === 'string' && id.trim())
    .map((id) => id.trim())));
  const country = countryID === undefined || countryID === null ? '' : String(countryID).trim();
  const hasCountry = /^\d+$/.test(country) && Number(country) > 0;

  return (
    <div
      className="journey-campaign-country-detail-row"
      role="group"
      aria-label={label('title')}
    >
      <Typography.Body>{label('title')}</Typography.Body>
      <Flex
        vertical
        gap="8px"
        className="journey-campaign-country-detail-value"
        style={{ minWidth: 0 }}
      >
        {!ids.length ? <Typography.Body>{label('empty')}</Typography.Body> : (
          <React.Fragment>
            {!hasCountry && <Typography.Body>{label('missing_country')}</Typography.Body>}
            {ids.map((id) => (hasCountry ? (
              <Typography.Link
                href={UCD_ROUTES_LINK.TRIDENT_CAMPAIGN_VIEW(country, id)}
                key={id}
                rel="noopener noreferrer"
                target="_blank"
                style={{ overflowWrap: 'anywhere' }}
              >
                {id}
              </Typography.Link>
            ) : <Typography.Body key={id}>{id}</Typography.Body>))}
          </React.Fragment>
        )}
      </Flex>
    </div>
  );
};

export default JourneyTridentCampaignLinks;
